import React, {useContext, useState} from 'react'
import { DataPoint } from "../../Pages/Live";
import StatsBox from './StatsBox';
import Chart from './Chart';
import { CategoriesFromChart, CategoriesFromConfig, dataToMap, filterDataToMap } from './chartHelpers';
import { Skid } from '../AvailableSkids/skidsWithConfigProvider';
import { ConfigContext } from '../ViewConfig/ConfigProvider';
interface ChartBoxProps{
    data:DataPoint[],
    skids?:Map<string, Skid>,
    options?:ChartBoxOptions,
    skid?:string
}
interface ChartBoxOptions{
    title?:string,
    showStats?:boolean
    horizontal?:boolean
}
function ChartBox(props:ChartBoxProps){
    const {data, options, skids, skid} = props
    const {title, showStats: initialShowStats} = options || {}
    const [showStats, setShowStats] = useState<boolean>(initialShowStats || false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const viewConfig = useContext(ConfigContext)
    if (error){
        return (
            <div style={{border:'1px solid #1E2A3B', borderRadius:5, padding:10, margin:10, display:'flex', flexDirection:'column', width:'100%', height:'100%'} }>
                <h3>{title}</h3>
                <p>Error: {error}</p>
            </div>
        )
    }
    if (loading){
        return (
            <div style={{border:'1px solid #1E2A3B', borderRadius:5, padding:10, margin:10, display:'flex', flexDirection:'column', width:'100%', height:'100%'} }>
                <h3>{title}</h3>
                <p>Loading...</p>
            </div>
        )
    }
    if (!data || data.length === 0){
        return (
            <div style={{border:'1px solid #1E2A3B', borderRadius:5, padding:10, margin:10, display:'flex', flexDirection:'column', width:'100%', height:'100%'} }>
                <h3>{title}</h3>
                <p>No Data, select skid to continue</p>
            </div>
        )
    }
    return (
        
        <div style={{border:'1px solid #1E2A3B', borderRadius:5, padding:10, margin:10, display:'flex', flexDirection:'column', width:'100%', height:'100%'} }>
            <h3>{title}</h3>
            <button onClick={()=>setShowStats(!showStats)}>{showStats?'Hide Stats':'Show Stats'}</button>
            {showStats && <StatsBox data={data}/>}
            {Array.from(viewConfig.charts.values()).map((chart)=>{
                console.log('chart:',chart)
                if (chart.enabled){
                    return (
                        <div key={chart.name} style={{border:'1px solid #1E2A3B', borderRadius:5, padding:10, margin:10, display:'flex', flexDirection:'column', width:'100%', height:'100%'} }>
                            <h4>{chart.name}</h4>
                            <Chart data={filterDataToMap(data, CategoriesFromChart(chart))} options={options} />
                        </div>
                    )
                }
            })}
            <Chart data={dataToMap(data)} options={{horizontal:true, title:title,showStats:initialShowStats}} />
        </div>
    )
}

export default ChartBox